import styled from 'styled-components'

import { theme } from '@/styles/theme'

export const Accordion = styled.section`
  display: flex;
  flex-direction: column;
  gap: 50px;

  .fXCaXP {
    margin: 20px 0px;
    border: 1px solid ${theme.colors.backgroundBlue};
  }

  > div {
    // アコーディオンタイトル
    > div:nth-of-type(1) {
      display: flex;
      align-items: center;
      gap: 10px;

      &:hover {
        cursor: pointer;

        > h4 {
          color: ${theme.colors.lightBlue};
        }
      }

      @media screen and (max-width: 1047px) {
        align-items: flex-start;
        gap: 6px;
      }

      > h4 {
        font-size: 24px;
        font-weight: bold;
        color: ${theme.colors.trialBlue};
        line-height: 33.6px;

        @media screen and (max-width: 1047px) {
          font-size: 18px;
          line-height: 23.4px;
        }
      }

      > span {
        // アコーディオンを開きっぱなしにすると不要な要素になるため描画しない
        transition: all 0.25s ease;
        overflow: hidden;
        position: relative;
        padding-top: 2px;
        padding-right: 10px;
        width: 40px;
        height: 40px;

        &::before,
        &::after {
          content: '';
          display: inline-block;
          width: 30px;
          height: 4px;
          position: absolute;
          top: 50%;
          background-image: url('/images/accordion.png');
        }
        &::after {
          transform: rotate(90deg);
          transition: transform 0.4s ease;
        }
        &.iZwYFc {
          &::after {
            transform: rotate(0);
          }
        }

        @media screen and (max-width: 1047px) {
          padding-top: 7px;
          padding-right: 16px;
          width: 16px;
          height: 23px;

          &::before,
          &::after {
            width: 16px;
            height: 2.13px;
          }
        }
      }
    }
    // アコーディオンタイトルとアコーディオン内項目の間のSpacer
    > div:nth-of-type(2) {
      width: 18px;
      height: 18px;
      @media (max-width: 1047px) {
        width: 10px;
        height: 10px;
      }
    }
    // アコーディオン内項目
    > div:nth-of-type(3) {
      &.bkpqNp {
        display: none;
        height: 0px;
      }
      > ul {
        width: 100%;

        > li {
          display: flex;
          align-items: center;
          gap: 50px;
          padding-top: 18px;
          padding-bottom: 20px;
          :not(:last-child) {
            border-bottom: 1px solid ${theme.colors.backgroundBlue};
          }
          @media screen and (max-width: 1047px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 2px;
          }

          > time {
            width: 10%;
            font-weight: 700;
            line-height: 1.6;
          }
          > h3 {
            display: flex;
            gap: 10px;
            > svg {
              transition: fill 0.3s ease;
              fill: ${theme.colors.trialBlue};
              width: 12px;
              height: 28px;
              flex-shrink: 0;
            }
            > p {
              font-size: 16px;
              letter-spacing: 0.64px;
              line-height: 26px;
              color: ${theme.colors.textTitle};
              @media screen and (max-width: 1047px) {
                font-size: 15px;
              }
              > a:hover { 
                text-decoration: underline;
                color: rgb(55, 134, 199);
              }
              > span {
                font-weight: 500;
                font-size: 14px;
                line-height: 1.6;
                color: ${theme.colors.textSecond};
                margin-left: 10px;
                @media screen and (max-width: 1047px) {
                  font-size: 13px;
                }
              }
            }
          }

          > a {
            transition: color 0.3s ease;
            display: flex;
            gap: 10px;
            width: 100%;

            &:hover > h3 {
              > svg {
                fill: ${theme.colors.hoverLightBlue};
              }
              > p {
                text-decoration: underline;
                color: ${theme.colors.hoverLightBlue};
                > span {
                  color: ${theme.colors.hoverLightBlue};
                  display: inline-block;
                }
              }
            }

            > h3 {
              display: flex;
              gap: 10px;
              > svg {
                transition: fill 0.3s ease;
                fill: ${theme.colors.trialBlue};
                width: 12px;
                height: 28px;
                flex-shrink: 0;
              }
              > p {
                font-size: 16px;
                letter-spacing: 0.64px;
                line-height: 26px;
                color: ${theme.colors.textTitle};
                @media screen and (max-width: 1047px) {
                  font-size: 15px;
                }
                > span {
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 1.6;
                  color: ${theme.colors.textSecond};
                  margin-left: 10px;
                  @media screen and (max-width: 1047px) {
                    font-size: 13px;
                  }
                }
              }
            }
          }
        }
      }
      // アコーディオン内項目が0件のときに表示される「ただいま掲載すべき事項はございません。」
      > span {
        font-size: 16px;
        line-height: 25.6px;
        color: ${theme.colors.textTitle};

        @media screen and (max-width: 1047px) {
          font-size: 15px;
          line-height: 24px;
        }
      }
    }
  }
`
